import { ProgramObject } from '@/types/epg/Program'
import { serializable } from 'serializr'
import Program from '@/shared/classes/epg/program/program'

class ProgramStreamIQ extends Program {
    @serializable genre: string

    constructor(programProps: ProgramObject) {
        super(programProps)
        this.genre = this.getGenre(programProps.genre)
    }
    getGenre = (type?: string | string[]) => {
        if (typeof type === 'string') {
            return type
        } else if (Array.isArray(type)) {
            return type.join(', ')
        }
        return 'GenreOthers'
    }

    static deserialize(programJson: string): Program {
        const programObj = JSON.parse(programJson)

        return new ProgramStreamIQ(programObj)
    }
}

export default ProgramStreamIQ
